import { ref } from 'vue';

// Aceleres 2026-09-14: mensagem de GRUPO que o WhatsApp não confirmou.
//
// O envio para a WAME responde 200 na hora mesmo quando a mensagem nunca vai
// sair (em 10-14/09/2026 a conexão Facundo ficou quatro dias com falha de
// criptografia em todos os grupos e a bolha dizia "enviada"). O que separa
// entrega de falha é o recibo: numa conexão saudável ele chega em segundos em
// todo envio de grupo. Três minutos sem recibo é, na prática, mensagem que não
// chegou.
//
// Só grupo: numa conversa individual o celular desligado do contato segura o
// recibo por horas, e o alerta viraria ruído.
export const UNCONFIRMED_AFTER_MS = 3 * 60 * 1000;

// Um relógio para todas as bolhas, e não um timer por mensagem.
const now = ref(Date.now());
let timer = null;

export function useUnconfirmedClock() {
  if (!timer && typeof window !== 'undefined') {
    timer = window.setInterval(() => {
      now.value = Date.now();
    }, 30 * 1000);
  }
  return now;
}

/**
 * @param {number|string} createdAt epoch em segundos (formato do Chatwoot)
 * @param {number} nowMs
 */
export function isPastConfirmationWindow(createdAt, nowMs) {
  const createdMs = Number(createdAt) * 1000;
  if (!Number.isFinite(createdMs) || createdMs <= 0) return false;
  return nowMs - createdMs >= UNCONFIRMED_AFTER_MS;
}

const OUTGOING = 1;

/**
 * Desde quando os envios para o grupo estão sem recibo, para a faixa acima do
 * campo de resposta. Uma bolha sem recibo pode ser um celular sem sinal; duas
 * seguidas, as mais recentes, sem nenhuma confirmada depois, é a conexão.
 *
 * @param {Array<object>} messages mensagens da conversa (formato da store)
 * @param {number} nowMs
 * @returns {number|null} created_at (s) da primeira mensagem presa, ou null
 */
export function groupDeliveryStuckSince(messages, nowMs) {
  const outgoing = (messages || [])
    .filter(
      message =>
        Number(message?.message_type) === OUTGOING &&
        !message?.private &&
        message?.status !== 'failed' &&
        message?.status !== 'progress'
    )
    .sort((a, b) => Number(a.created_at) - Number(b.created_at));

  const stuck = [];
  for (let i = outgoing.length - 1; i >= 0; i -= 1) {
    if (outgoing[i].status !== 'sent') break;
    stuck.unshift(outgoing[i]);
  }
  if (stuck.length < 2) return null;
  if (!isPastConfirmationWindow(stuck[stuck.length - 1].created_at, nowMs)) {
    return null;
  }
  return Number(stuck[0].created_at);
}
